import { Component, OnInit } from '@angular/core';
import { GlobalServiceService } from './global-service.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  height: number;
  width: number;
  proportion: number = 0.161;
  constructor(private service: GlobalServiceService) { }

  ngOnInit(){
    this.onResize();
  }

  onResize(){
    this.height = this.service.getHeight(this.proportion);
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/footer.component.ts